import ReactGA from 'react-ga4';

const measurementId = process.env.GA_MEASUREMENT_ID;

export const isAnalyticsEnabled = Boolean(measurementId);

if (isAnalyticsEnabled) {
	ReactGA.initialize(measurementId, {
		gtagOptions: {
			send_page_view: false,
		},
	});
}

export function trackPageView(page, title) {
	if (!isAnalyticsEnabled) return;

	ReactGA.send({
		hitType: 'pageview',
		page,
		title,
	});
}
